import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { LinkedinIcon, ArrowRightIcon } from 'lucide-react';
import { PageShell } from '../components/layout/PageShell';
import { SmartImage } from '../components/common/SmartImage';
import { useI18n } from '../lib/i18n';
import { MILESTONES, TEAM } from '../lib/data';
export function Journey() {
  const {
    t,
    lang
  } = useI18n();
  return <PageShell data-id="element-286" data-mp="117ldyyvmc1so">
      <section className="mx-auto max-w-container px-4 py-12 sm:px-6" data-id="element-287" data-mp="11739jeysyh9o">
        <div className="text-center" data-id="element-288" data-mp="x5rjx9fxhw1h">
          <h1 className="text-3xl font-extrabold text-white sm:text-4xl" data-id="element-289" data-mp="x6t546qnrywx">
            {t('journey_title')}
          </h1>
          <p className="mt-2 text-silver/70" data-id="element-290" data-mp="1ay7mk94x3s1v">{t('journey_sub')}</p>
        </div>

        {/* Timeline */}
        <ol className="relative mx-auto mt-12 max-w-2xl border-l border-[rgba(217,217,217,0.2)] pl-6" data-id="element-291" data-mp="ig2dayp2gztt">
          {MILESTONES.map((m, i) => <motion.li key={i} initial={{
          opacity: 0,
          x: -12
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.05
        }} className="mb-8 last:mb-0" data-id="element-292" data-mp="dg7msw97ec9a" data-mpi={i}>
              <span className="absolute -left-[9px] mt-1.5 h-4 w-4 rounded-full border-2 border-neon bg-navy" data-id="element-293" data-mp="16pgnk8uryoj6" />
              <p className="text-sm font-semibold text-neon" data-id="element-294" data-mp="dyyn7flfr19g">
                {lang === 'en' ? m.date_en : m.date_am}
              </p>
              <p className="mt-1 text-silver/85" data-id="element-295" data-mp="ix03jsrh8mh8">
                {lang === 'en' ? m.title_en : m.title_am}
              </p>
            </motion.li>)}
        </ol>

        {/* Team */}
        <div className="mt-16" data-id="element-296" data-mp="1udzy6v1ardef">
          <h2 className="mb-8 text-center text-2xl font-bold text-white sm:text-3xl" data-id="element-297" data-mp="1ucyk0hoziash">
            {t('the_team')}
          </h2>
          <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-4" data-id="element-298" data-mp="3vffvybfhtm1x">
            {TEAM.map((member, i) => <motion.div key={member.id} initial={{
            opacity: 0,
            y: 16
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: i * 0.08
          }} className="glass-card flex flex-col overflow-hidden p-0" data-id="element-299" data-mp="3qgmr17e9v3dd" data-mpi={i}>
                <div className="aspect-square w-full overflow-hidden bg-white/5" data-id="element-300" data-mp="3lhta14zs0u8g">
                  <SmartImage src={member.image} alt={member.name} className="h-full w-full object-cover" data-id="element-301" data-mp="3gqthsd1lr0ca" />
                </div>
                <div className="flex flex-1 flex-col p-4" data-id="element-302" data-mp="2o2filtys1xz5">
                  <h3 className="font-semibold text-white" data-id="element-303" data-mp="2nztc7xnmhoii">
                    {lang === 'en' ? member.name : member.name_am}
                  </h3>
                  <p className="mt-0.5 text-sm text-neon" data-id="element-304" data-mp="18atq5eh510vj">
                    {lang === 'en' ? member.role_en : member.role_am}
                  </p>
                  <p className="mt-1 text-xs text-silver/60" data-id="element-305" data-mp="uh2he8b8dl0v">
                    {lang === 'en' ? member.expertise_en : member.expertise_am}
                  </p>

                  <div className="mt-4 flex items-center justify-between" data-id="element-306" data-mp="1n95n7m8fabn8">
                    <Link to={'/team/' + member.id} className="inline-flex items-center gap-1 text-sm font-medium text-silver hover:text-white" data-id="element-307" data-mp="1r9xui9xqi6gv">
                      {t('view_profile')}
                      <ArrowRightIcon className="h-3.5 w-3.5" data-id="element-308" data-mp="1iauejetv676l" />
                    </Link>
                    <a href={member.linkedin} target="_blank" rel="noopener noreferrer" aria-label={`${member.name} on LinkedIn`} className="rounded-md p-1.5 text-silver/70 hover:text-neon" data-id="element-309" data-mp="1t6kb2hr1r3k">
                      <LinkedinIcon className="h-4 w-4" data-id="element-310" data-mp="haoddgy5z0ly" />
                    </a>
                  </div>
                </div>
              </motion.div>)}
          </div>
        </div>
      </section>
    </PageShell>;
}